/* c8 ignore start */
/**
 * A promise that never settles
 */
export const foreverPromise = new Promise(() => { });
/* c8 ignore end */
